import { forwardRef } from "react";
import { IconButton } from "waapi/waap-ui/components/IconButton/IconButton.js";
import { Send2Bold } from "waapi/waap-ui/components/Iconsax/Send2Bold.js";
import { StyledLink } from "./styles.js";

export const SmallCustomizableButton = forwardRef<HTMLDivElement>((_, ref): JSX.Element => {
    return (
        <StyledLink ref={ref}>
            <IconButton icon={Send2Bold} color="gradient" size="small" />
        </StyledLink>
    );
});
